export default __webpack_public_path__ + "static/media/Q6_1_resized.d6e7c13e.jpg";